var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "designer-sidebar__wrapper column is-one-quarter is-full-mobile",
    },
    [
      _vm.visualEditor
        ? _c(
            "div",
            {
              staticClass:
                "product-layout-options product-layout-options-visual",
            },
            [
              _vm.languageStrings.close
                ? _c(
                    "button",
                    {
                      staticClass: "button button__close",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.visualEditor = !_vm.visualEditor
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.languageStrings.close))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.visualEditorFonts
                ? _c(
                    "div",
                    { staticClass: "product-layout-options__wrapper" },
                    [
                      _c("div", { staticClass: "type-tester" }, [
                        _c("div", { staticClass: "type-tester__font-name" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.currentDesign.font.name) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "type-tester__font-test",
                            class: `${
                              _vm.currentDesign.uppercase
                                ? "text-uppercase"
                                : ""
                            } ${_vm.currentDesign.font.slug}`,
                          },
                          [
                            _vm.checkTextrows()
                              ? _c("div", [_vm._v(_vm._s(_vm.textRows[0]))])
                              : _c("div", [
                                  _vm.languageStrings.text_in_sign
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.languageStrings.text_in_sign
                                          )
                                        ),
                                      ])
                                    : _c("span", [_vm._v("Text")]),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "type-tester__available-styles" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "button-bold",
                                class: `${
                                  _vm.currentDesign.font.bold ? "enabled" : ""
                                }`,
                              },
                              [_vm._v("\n            B\n          ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "button-italic",
                                class: `${
                                  _vm.currentDesign.font.italic ? "enabled" : ""
                                }`,
                              },
                              [_vm._v("\n            I\n          ")]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "product-layout-options" }, [
                        _vm.visualFontsViewer
                          ? _c(
                              "aside",
                              { staticClass: "control font-variant" },
                              [
                                _c("div", { staticClass: "form-group" }, [
                                  _vm.languageStrings.font
                                    ? _c(
                                        "label",
                                        {
                                          staticClass: "control-group-title",
                                          attrs: { for: "font_all" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.languageStrings.font)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "font__list",
                                        attrs: {
                                          id: "font_all",
                                          name: "font_all",
                                        },
                                      },
                                      _vm._l(
                                        _vm.getFonts,
                                        function (fontVariant, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "font-item",
                                              class:
                                                _vm.font.slug ==
                                                fontVariant.slug
                                                  ? "active"
                                                  : "",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "button",
                                                  class: `${fontVariant.slug} ${
                                                    _vm.currentDesign.font
                                                      .slug ===
                                                      fontVariant.slug &&
                                                    "active"
                                                  }`,
                                                  attrs: { role: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      ;(_vm.currentDesign.font =
                                                        fontVariant),
                                                        _vm.handleInputChange
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(fontVariant.name) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.visualEditorSize
                        ? _c("div", { staticClass: "product-layout-options" }, [
                            _vm.getTextSizes && _vm.visualTextSizeViewer
                              ? _c(
                                  "aside",
                                  { staticClass: "control font-size" },
                                  [
                                    _c("div", { staticClass: "form-group" }, [
                                      _vm.languageStrings.textsize
                                        ? _c(
                                            "label",
                                            {
                                              staticClass:
                                                "control-group-title",
                                              attrs: {
                                                for: "fontsize_all fontsize",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.languageStrings.textsize
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {}, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "sizes__list",
                                            attrs: { id: "fontsize_all" },
                                          },
                                          _vm._l(
                                            _vm.getTextSizes,
                                            function (size, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "textsize-item",
                                                  class:
                                                    _vm.textsize ==
                                                    size.truesize
                                                      ? "active"
                                                      : "",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "button",
                                                      attrs: {
                                                        role: "button",
                                                        "data-size":
                                                          size.truesize,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          ;(_vm.currentDesign.fontSize =
                                                            size.truesize),
                                                            _vm.handleInputChange
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(size.name) +
                                                          " mm\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "designer-sidebar" },
        [
          _c("div", { staticClass: "designer-sidebar" }, [
            _c(
              "div",
              { staticClass: "fast-tools__container" },
              [
                _c("FastTools", {
                  attrs: {
                    getSign: _vm.getSign,
                    currentDesign: _vm.currentDesign,
                    advancedEditor: _vm.advancedEditor,
                    languageStrings: _vm.languageStrings,
                    visualEditorVisible: _vm.visualEditor,
                  },
                  on: {
                    handleDesignChanges: _vm.handleDesignChanges,
                    toggleVisualDesigner: _vm.toggleVisualDesigner,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("aside", { staticClass: "product-information" }, [
              _vm.getSign.name
                ? _c("h1", { staticClass: "product-name" }, [
                    _vm._v(_vm._s(_vm.getSign.name)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "product-material" }, [
                _vm.languageStrings.color
                  ? _c("span", [_vm._v(_vm._s(_vm.languageStrings.color))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.languageStrings.material
                  ? _c("span", { staticClass: "product-variant" }, [
                      _vm._v(_vm._s(_vm.languageStrings.material) + ","),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.getSign.realwidth && _vm.getSign.realheight
                ? _c("div", { staticClass: "product-size" }, [
                    _c("span", [_vm._v(_vm._s(_vm.getSign.realwidth))]),
                    _vm._v(" x\n          "),
                    _c("span", [_vm._v(_vm._s(_vm.getSign.realheight))]),
                    _vm._v(" mm\n        "),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "product-layout-options" }, [
              _vm.languageStrings.text_in_sign
                ? _c("div", { staticClass: "control-group-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.languageStrings.text_in_sign) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.debug
                ? _c("div", [
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.exportToSvg.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Export SVG")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getSign.rowsnum
                ? _c(
                    "aside",
                    { staticClass: "control order-textrows" },
                    [
                      _vm._l(Number(_vm.getSign.rowsnum), function (index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "form-group linehandler textrow",
                            class:
                              index > 2 && _vm.showAllLines ? "is-hidden" : "",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.textRows[index - 1],
                                  expression: "textRows[index - 1]",
                                },
                              ],
                              staticClass: "input text",
                              attrs: {
                                type: "text",
                                id: "row" + index,
                                name: "row" + index,
                                placeholder:
                                  _vm.handleTextRowPlaceholder(index),
                              },
                              domProps: { value: _vm.textRows[index - 1] },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.textRows,
                                      index - 1,
                                      $event.target.value
                                    )
                                  },
                                  _vm.handleInputChange,
                                ],
                              },
                            }),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.showAllLines && Number(_vm.getSign.rowsnum) > 1
                        ? _c(
                            "button",
                            {
                              staticClass: "add-row-button",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.showAllLines = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.languageStrings.extra_textrows) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "control-group-title" }),
              _vm._v(" "),
              _vm.getFonts
                ? _c("aside", { staticClass: "control font-variant" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm.languageStrings.font
                        ? _c(
                            "label",
                            {
                              staticClass: "control-group-title",
                              attrs: { for: "font_all" },
                            },
                            [_vm._v(_vm._s(_vm.languageStrings.font))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "select is-fullwidth" }, [
                        _c(
                          "select",
                          {
                            staticClass: "font",
                            attrs: { id: "font_all", name: "font_all" },
                            on: {
                              change: function ($event) {
                                return _vm.handleSelectChange("font", $event)
                              },
                            },
                          },
                          _vm._l(_vm.getFonts, function (fontVariant, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                staticClass: "font-item",
                                domProps: {
                                  value: fontVariant.slug,
                                  selected:
                                    fontVariant.slug ===
                                    _vm.currentDesign.font.slug,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(fontVariant.name) +
                                    "\n                "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getTextSizes
                ? _c("aside", { staticClass: "control font-size" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm.languageStrings.textsize
                        ? _c(
                            "label",
                            {
                              staticClass: "control-group-title",
                              attrs: { for: "fontsize_all fontsize" },
                            },
                            [_vm._v(_vm._s(_vm.languageStrings.textsize))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "select is-fullwidth" }, [
                        _c(
                          "select",
                          {
                            attrs: { id: "fontsize_all", name: "fontsize_all" },
                            on: {
                              change: function ($event) {
                                return _vm.handleSelectChange(
                                  "textsize",
                                  $event
                                )
                              },
                            },
                          },
                          _vm._l(_vm.getTextSizes, function (size, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                domProps: {
                                  value: size.truesize,
                                  selected:
                                    Number(size.truesize) ===
                                    _vm.currentDesign.fontSize,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(size.name) +
                                    " mm\n                  " +
                                    _vm._s(_vm.checkIfLaserEngraving(size)) +
                                    "\n                  "
                                ),
                                _vm.shouldHaveFee() &&
                                size.fee &&
                                size.fee > 0 &&
                                _vm.appSettings.currency
                                  ? [
                                      _vm._v(
                                        "(+" +
                                          _vm._s(size.fee) +
                                          " " +
                                          _vm._s(_vm.appSettings.currency) +
                                          ")"
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "aside",
                { staticClass: "control font-weight-style is-hidden" },
                [
                  _c("div", { staticClass: "text-layout-options" }, [
                    _vm.currentDesign.font.bold
                      ? _c(
                          "button",
                          {
                            staticClass: "button button-bold is-fullwidth mt-2",
                            class: _vm.fontbold ? "active" : "",
                            attrs: { type: "button", title: "Fet text" },
                            on: {
                              click: function ($event) {
                                ;(_vm.fontbold = !_vm.fontbold),
                                  _vm.handleSelectChange()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "button-badge" }, [
                              _vm._v("B"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "is-sr-only" }, [
                              _vm._v("Fet text"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentDesign.font.italic
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "button button-italic is-fullwidth mt-2",
                            class: _vm.fontitalic ? "active" : "",
                            attrs: { type: "button", title: "Italic text" },
                            on: {
                              click: function ($event) {
                                ;(_vm.fontitalic = !_vm.fontitalic),
                                  _vm.handleSelectChange()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "button-badge" }, [
                              _vm._v("I"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "is-sr-only" }, [
                              _vm._v("Kursiv"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.advancedEditor
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.visualEditor = !_vm.visualEditor
                          },
                        },
                      },
                      [_vm._v("\n            Visual fonts\n          ")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.appSettings.engraving_options
                ? _c(
                    "aside",
                    { staticClass: "control product-engraving__selector" },
                    [
                      _vm.languageStrings.engraving_type
                        ? _c("div", { staticClass: "control-group-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.languageStrings.engraving_type) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.checkIfLaser()
                        ? _c("div", [
                            _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "button",
                                  class:
                                    _vm.currentDesign.engraving_type ===
                                      "laquer" && "active",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      ;(_vm.currentDesign.engraving_type =
                                        "laquer"),
                                        _vm.handleSelectChange()
                                    },
                                  },
                                },
                                [
                                  _vm.getSign.textcolor
                                    ? _c("div", {
                                        staticClass: "color-block",
                                        style: {
                                          "background-color":
                                            _vm.getSign.textcolor,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.languageStrings.laquer_engraving
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.engravingSelectorPricing
                              ? _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button",
                                      class:
                                        _vm.currentDesign.engraving_type ===
                                          "laser" && "active",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          ;(_vm.currentDesign.engraving_type =
                                            "laser"),
                                            _vm.handleSelectChange()
                                        },
                                      },
                                    },
                                    [
                                      _vm.getSign.textcolorshadow
                                        ? _c("div", {
                                            staticClass: "color-block",
                                            style: {
                                              "background-color":
                                                _vm.getSign.textcolorshadow,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.languageStrings.laser_engraving
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "button",
                                  class:
                                    _vm.currentDesign.engraving_type ===
                                      "unfilled" && "active",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      ;(_vm.currentDesign.engraving_type =
                                        "unfilled"),
                                        _vm.handleSelectChange()
                                    },
                                  },
                                },
                                [
                                  _vm.getSign.textcolorshadow
                                    ? _c("div", {
                                        staticClass: "color-block",
                                        style: {
                                          "background-color":
                                            _vm.getSign.textcolorshadow,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.languageStrings
                                          .laquer_unfilled_engraving
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ])
                        : _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "product-promises-item laser-icon",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.languageStrings.laser_engraving
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "engraving-information" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#", role: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.displayEngravingInformation()
                              },
                            },
                          },
                          [_vm._v("Läs om våra gravyrtyper")]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("aside", { staticClass: "product-delivery-info" }, [
                _c("ul", [
                  _c("li", [
                    !_vm.producOutOfStock && _vm.languageStrings.in_stock
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "product-promises-item stock-availability",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.languageStrings.in_stock) +
                                "\n              "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.producOutOfStock
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "product-promises-item stock-availability out-of-stock",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.languageStrings.out_of_stock) +
                                "\n              "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  !_vm.appSettings.engraving_options
                    ? _c("li", [
                        !_vm.checkIfLaser()
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "product-promises-item gravure-icon",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.languageStrings.laquer_engraving
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "product-promises-item laser-icon",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.languageStrings.laser_engraving
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.interfaceList.length > 0
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.interfaceList,
                          function (interfaceItem, index) {
                            return _c("div", { key: index }, [
                              interfaceItem === "sign_interface_tape"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-promises-item tape-included",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.languageStrings
                                              .tape_included_short
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              interfaceItem === "sign_interface_militaryclip"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-promises-item militaryclip-included",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Militärfäste\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              interfaceItem === "sign_interface_screw"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-promises-item screws-included",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.languageStrings
                                              .screws_included_short
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              interfaceItem === "sign_interface_safetypin"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-promises-item safetypin-included",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Säkerhetsnål\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              interfaceItem === "sign_interface_metalmagnet"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-promises-item militaryclip-included",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Magnet metall\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              interfaceItem === "sign_interface_plasticmagnet"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-promises-item militaryclip-included",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Magnet plast\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              interfaceItem === "sign_interface_keyring"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-promises-item militaryclip-included",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Nyckelring\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("DialogElement", {
            attrs: { dialogToggle: _vm.dialogToggle, maxWidth: "600" },
            on: { closeDialog: _vm.closeDialog },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [_vm._v("Våra gravyrtyper")]
                },
                proxy: true,
              },
              {
                key: "content",
                fn: function () {
                  return [_vm._v(" INfo ")]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }